export default __webpack_public_path__ + "static/media/placeholder-image.f19325e3.svg";